<div class="bloc-area width100pc dis-line">
	<ng-container #fieldComponent></ng-container>
</div>